"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPayouts = exports.exportPayouts = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _moment = _interopRequireDefault(require("@package/moment"));

var _request = _interopRequireDefault(require("@package/request"));

var _utils = require("@package/utils");

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("./slice");

var getPayouts = function getPayouts() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var params, result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                message: 'Получение списка выплат'
              });
              dispatch((0, _slice.getPayoutsRequestAction)());
              params = {};

              if (query['order'] === 'created') {
                params['creationDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                params['creationDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              } else if (query['order'] === 'updated') {
                params['lastUpdatedDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                params['lastUpdatedDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              } else if (query['order'] === 'both') {
                params['allDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                params['allDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              }

              if (query['status'] > -1) {
                params['status'] = query['status'];
              }

              if (query['searchTerm']) {
                params['searchTerm'] = query['searchTerm'];
              }

              if (query['amountFrom']) {
                params['minAmount'] = query['amountFrom'];
              }

              if (query['amountTo']) {
                params['maxAmount'] = query['amountTo'];
              }

              if (query['page'] && typeof query['page'] === 'number' && query['page'] > 0) {
                params['skip'] = (query['page'] - 1) * query['take'];
              }

              if (query['take']) {
                params['take'] = query['take'];
              }

              if (!query['shopDemoMode']) {
                params['shopDemoMode'] = false;
              }

              _context.next = 14;
              return (0, _request["default"])({
                url: '/payouts',
                method: 'get',
                params: params
              });

            case 14:
              result = _context.sent;
              dispatch((0, _slice.getPayoutsRequestSuccessAction)(result));
              _context.next = 28;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return", void 0);

            case 22:
              if (!(_context.t0['status'] === 404)) {
                _context.next = 25;
                break;
              }

              dispatch((0, _slice.notFoundAction)());
              return _context.abrupt("return");

            case 25:
              dispatch((0, _slice.getPayoutsRequestFailAction)(_context.t0));
              dispatch(notifications.pushFail(_context.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при получении списка выплат'
              });

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 18]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getPayouts = getPayouts;

var exportPayouts = function exportPayouts() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch) {
      var formData, result, blob;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0, _logger.push)({
                message: 'Экспорт списка выплат'
              });
              dispatch((0, _slice.exportPayoutsRequestAction)());
              formData = {};

              if (query['order'] === 'created') {
                formData['creationDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                formData['creationDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              } else if (query['order'] === 'updated') {
                formData['lastUpdatedDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                formData['lastUpdatedDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              } else if (query['order'] === 'both') {
                formData['allDateFrom'] = (0, _moment["default"])(query['dateFrom']).format("YYYY-MM-DD HH:mm:00.000000+03:00");
                formData['allDateTo'] = (0, _moment["default"])(query['dateTo']).format("YYYY-MM-DD HH:mm:59.999999+03:00");
              }

              if (query['status'] > -1) {
                formData['status'] = query['status'];
              }

              if (query['searchTerm']) {
                formData['searchTerm'] = query['searchTerm'];
              }

              if (query['amountFrom']) {
                formData['minAmount'] = query['amountFrom'];
              }

              if (query['amountTo']) {
                formData['maxAmount'] = query['amountTo'];
              }

              query['shopDemoMode'] ? delete formData['shopDemoMode'] : formData['shopDemoMode'] = false;
              _context2.next = 12;
              return (0, _request["default"])({
                url: '/payouts/export',
                method: 'get',
                responseType: 'text',
                params: formData
              });

            case 12:
              result = _context2.sent;
              blob = new Blob(["\uFEFF" + result], {
                type: 'text/csv;charset=utf-8;'
              });
              (0, _utils.saveAs)(blob, "payouts-".concat((0, _moment["default"])().format('DD-MM-YYYY'), ".csv"));
              dispatch((0, _slice.exportPayoutsRequestSuccessAction)());
              dispatch(notifications.pushSuccess('Операция выполнена успешно'));
              _context2.next = 26;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0 instanceof _errors.UnauthorizedError)) {
                _context2.next = 23;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 23:
              dispatch((0, _slice.exportPayoutsRequestFailAction)(_context2.t0['data']));
              dispatch(notifications.pushFail(_context2.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при экспорте выплат'
              });

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 19]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.exportPayouts = exportPayouts;